import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

export const LaterSection = ({ title, children, testid }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="rounded-2xl border border-dashed border-brand-soft" data-testid={testid || `later-${title.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
      <button type="button" onClick={() => setOpen(!open)} className="w-full flex items-center justify-between gap-3 px-4 py-3 text-left">
        <span className="font-semibold text-brand-greenDeep">{title} <span className="ml-1 text-xs font-normal text-brand-green/50">(facultatif) · Compléter plus tard</span></span>
        <ChevronDown className={`w-4 h-4 text-brand-green/50 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && <div className="px-4 pb-4 space-y-4">{children}</div>}
    </div>
  );
};

export const HelpTip = ({ text }) => {
  const [show, setShow] = useState(false);
  return (
    <span className="relative inline-block align-middle">
      <span role="button" tabIndex={0} title={text} onClick={(e) => { e.preventDefault(); e.stopPropagation(); setShow(!show); }} onBlur={() => setShow(false)}
        className="inline-grid place-items-center w-4 h-4 ml-1 rounded-full bg-brand-softer text-[10px] font-bold text-brand-green/60 cursor-help" data-testid="help-tip">?</span>
      {show && <span className="absolute z-30 left-0 top-6 w-64 p-3 rounded-xl bg-brand-greenDeep text-white text-xs font-normal leading-relaxed shadow-lg" data-testid="help-tip-pop">{text}</span>}
    </span>
  );
};
